import React, { useState } from 'react';
import "./styles/LoginPageLayer.css"
import { useNavigate } from 'react-router-dom';
import apiProvider from '../apiProvider/api';
import { useDispatch } from 'react-redux';
import { login } from '../redux/authSlice';
import adminUserApi from '../apiProvider/adminuserapi';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';

export default function LoginPageLayer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('admin');
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    phoneNumber: '',
  });
  const [showPin, setShowPin] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [formErrors, setFormErros] = useState({})
  // email:admin@rameshtraders.in
  // password:Ramesh@1490
  // Forgot password states
  const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
  const [forgotPasswordData, setForgotPasswordData] = useState({
    phoneNumber: '',
    otp: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState('');
  const [showNewPin, setShowNewPin] = useState(false);
  const [showConfirmNewPin, setShowConfirmNewPin] = useState(false);
  const [userId, setUserId] = useState("")
  const togglePassword = () => setShowPassword(!showPassword);
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveTab(tab);
        setIsTransitioning(false);
      }, 300);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormErros({})
    if (name === 'phoneNumber' && (value.length > 10 || !/^\d*$/.test(value))) {
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePinChange = (value, index) => {
    // Allow only numbers
    if (value && !/^\d$/.test(value)) return;

    const newPin = formData.password.split('');
    newPin[index] = value;
    const combinedPin = newPin.join('').slice(0, 4);

    setFormData(prev => ({
      ...prev,
      password: combinedPin
    }));

    // Auto-focus next field
    if (value && index < 3) {
      document.getElementById(`pin-${index + 1}`).focus();
    }
  };

  const handlePinKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !formData.password[index] && index > 0) {
      document.getElementById(`pin-${index - 1}`).focus();
    }
  };

  const handlePinPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4);
    if (pastedData) {
      setFormData(prev => ({
        ...prev,
        password: pastedData
      }));
      // Focus the last field or the next empty one
      const nextIndex = Math.min(pastedData.length, 3);
      document.getElementById(`pin-${nextIndex === 4 ? 3 : nextIndex}`).focus();
    }
  };

  const handleForgotPasswordChange = (e) => {
    const { name, value } = e.target;

    // Validation based on field name
    if (name === 'phoneNumber' && (value.length > 10 || !/^\d*$/.test(value))) {
      return;
    }

    if ((name === 'newPassword' || name === 'confirmPassword') &&
      (value.length > 4 || !/^\d*$/.test(value))) {
      return;
    }

    if (name === 'otp' && (value.length > 6 || !/^\d*$/.test(value))) {
      return;
    }

    setForgotPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleForgotPasswordPinChange = (value, index, fieldName) => {
    if (value && !/^\d$/.test(value)) return;

    const currentPin = (forgotPasswordData[fieldName] || '').split('');
    currentPin[index] = value;
    const combinedPin = currentPin.join('').slice(0, 4);

    setForgotPasswordData(prev => ({
      ...prev,
      [fieldName]: combinedPin
    }));

    if (value && index < 3) {
      const nextInput = document.getElementById(`${fieldName}-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleForgotPasswordPinKeyDown = (e, index, fieldName) => {
    if (e.key === 'Backspace' && !forgotPasswordData[fieldName][index] && index > 0) {
      const prevInput = document.getElementById(`${fieldName}-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleForgotPasswordPinPaste = (e, fieldName) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4);
    if (pastedData) {
      setForgotPasswordData(prev => ({
        ...prev,
        [fieldName]: pastedData
      }));
      const nextIndex = Math.min(pastedData.length, 3);
      const targetInput = document.getElementById(`${fieldName}-${nextIndex === 4 ? 3 : nextIndex}`);
      if (targetInput) targetInput.focus();
    }
  };

  const handleAdminSubmit = async (e) => {
    e.preventDefault();
    let errors = {}
    // Basic validations
    if (!formData.email) {
      errors.email = ("Email is required");
      setFormErros(errors)
      return;
    }

    // Email format validation (simple regex)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      errors.email = ("Please enter a valid email address");
      setFormErros(errors)
      return;
    }

    if (!formData.password) {
      errors.password = ("Password is required");
      setFormErros(errors)
      return;
    }

    try {
      const response = await apiProvider.adminLogin({
        email: formData.email,
        password: formData.password,
      });

      if (response.status) {
        const token = response.data.data.token;
        const decodedToken = jwtDecode(token);
        const userId = decodedToken.id;

        const userData = await adminUserApi.Userbyid(userId);

        if (userData.status) {
          dispatch(login({ token: token, user: userData.response.data }));

          // Reset form
          setFormData({
            email: "",
            password: "",
            phoneNumber: "",
          });

          navigate("/dashboard");
        } else {
          alert("Failed to fetch user data.");
        }
      } else {
        alert("Login failed. Please check credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      // alert("Something went wrong. Please try again later.");
    }
  };


  const handleAdminUsersSubmit = async (e) => {
    e.preventDefault();
    let errors = {}
    if (!formData.phoneNumber) {
      errors.phoneNumber = ("Phone number is required");
      setFormErros(errors)
      return;
    }
    if (formData.phoneNumber.length !== 10) {
      errors.phoneNumber = ("Please enter a valid 10-digit phone number");
      setFormErros(errors)
      return;
    }
    if (!formData.password) {
      errors.password = ("PIN is required");
      setFormErros(errors)
      return;
    }
    if (formData.password.length !== 4) {
      errors.password = ("PIN must be 4 digits");
      setFormErros(errors)
      return;
    }

    try {
      const response = await apiProvider.adminLogin({
        phoneNumber: formData.phoneNumber,
        password: formData.password,
      });

      if (response.status) {
        const token = response.data.data.token;
        const decodedToken = jwtDecode(token);
        const userId = decodedToken.id;
        const userData = await adminUserApi.Userbyid(userId);

        if (userData.status) {
          dispatch(login({ token: token, user: userData.response.data }));
          setFormData({
            email: '',
            password: '',
            phoneNumber: '',
          })
          navigate("/dashboard");
        } else {
          alert("Failed to fetch user data.");
        }
      } else {
        alert("Login failed. Please check phone number and PIN.");
      }
    } catch (error) {
      console.error("Login error:", error);
      // toast.error("Please enter the valid email & password")
    }
  };

  // Handle send OTP for forgot password
  const handleSendOtp = async () => {

    if (forgotPasswordData.phoneNumber.length !== 10) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }
    try {
      const response = await apiProvider.adminForgotPasword(forgotPasswordData.phoneNumber)
      console.log(response, "response")
      console.log(response?.response?.data?.data?.userId)
      if (response.status) {
        toast(response?.response?.data?.message)
        setUserId(response?.response?.data?.data?.userId)
        setTimeout(() => {
          // const otp = Math.floor(100000 + Math.random() * 900000).toString();
          setGeneratedOtp("1234");
          // console.log("Generated OTP:", otp);
          setOtpSent(true);
          alert(`OTP has been sent to ${forgotPasswordData.phoneNumber}. Check console for OTP.`);
        }, 2000);
      }
    } catch (error) {
      console.error("Login error:", error);
      // toast.error("Please enter the valid email & password")
    }
  };

  // Handle OTP verification
  const handleVerifyOtp = () => {
    if (forgotPasswordData.otp === generatedOtp) {
      setOtpVerified(true);
      alert("OTP verified successfully. You can now reset your PIN.");
    } else {
      alert("Invalid OTP. Please try again.");
    }
  };

  // Handle password reset
  const handleResetPassword = async () => {
    if (forgotPasswordData.newPassword.length !== 4) {
      alert("New PIN must be 4 digits");
      return;
    }

    if (forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword) {
      alert("PINs do not match");
      return;
    }

    try {
      let input = {
        userId: userId,
        newPassword: forgotPasswordData.newPassword
      }
      const response = await apiProvider.changePassword(input)
      console.log(response, "response")
      console.log("Password reset data:", {
        phoneNumber: forgotPasswordData.phoneNumber,
        newPassword: forgotPasswordData.newPassword
      });

      alert("PIN reset successfully. You can now login with your new PIN.");

      // Reset the forgot password flow
      setForgotPasswordActive(false);
      setOtpSent(false);
      setOtpVerified(false);
      setForgotPasswordData({
        phoneNumber: '',
        otp: '',
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
      console.error("Password reset error:", error);
      alert("An error occurred while resetting your PIN. Please try again.");
    }
  };

  return (
    <div className="authentication-bg min-vh-100 colors-boutique-login">
      <div className="bg-overlay"></div>
      <div className="container">
        <div className="d-flex flex-column min-vh-100 px-3 pt-4">
          <div className="row justify-content-center my-auto">
            <div className="col-md-8 col-lg-6 col-xl-5">
              {/* Logo removed from here to place inside card */}

              <div className="card">
                <div className="card-body p-4">
                  <div className="text-center mb-4">
                    <a href="index" className="d-block d-flex justify-content-center auth-logo">
                      <img
                        src="/assets/images/logo/Colors-logo.jpg"
                        alt="COLOURS BOUTIQUE"
                        height="80"
                        className="img auth-logo-dark"
                      />
                    </a>
                  </div>
                  <div className="card-header bg-transparent border-bottom-0 p-0 mb-4">
                    {!forgotPasswordActive ? (
                      <ul className="nav nav-tabs nav-tabs-custom nav-justified">
                        <li
                          className="nav-item"
                          style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
                          onClick={() => {
                            toggleTab('admin');
                            setFormData({ email: '', password: '', phoneNumber: '' });
                          }}
                        >
                          <span className={`nav-link ${activeTab === 'admin' ? 'active' : ''}`} style={{ pointerEvents: 'none' }}>
                            Admin
                          </span>
                        </li>
                        <li
                          className="nav-item"
                          style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
                          onClick={() => {
                            toggleTab('adminUsers');
                            setFormData({ email: '', password: '', phoneNumber: '' });
                          }}
                        >
                          <span className={`nav-link ${activeTab === 'adminUsers' ? 'active' : ''}`} style={{ pointerEvents: 'none' }}>
                            Admin User
                          </span>
                        </li>
                      </ul>
                    ) : (
                      <div className="text-center">
                        <h5>Reset Your PIN</h5>
                      </div>
                    )}
                  </div>
                  {/* End of card header section, still inside card-body */}


                  {!forgotPasswordActive ? (
                    <>
                      <div className="text-center mt-2">
                        <h5>Welcome Back!</h5>
                        <p className="text-muted">Sign in to continue to COLOURS BOUTIQUE.</p>
                      </div>

                      <div className="p-2 mt-4">
                        <form
                          onSubmit={handleAdminSubmit}
                          noValidate
                          className={`auth-input ${activeTab === 'admin' ? '' : 'd-none'}`}
                          style={{
                            transition: 'all 0.3s ease',
                            opacity: isTransitioning ? 0 : 1,
                            transform: isTransitioning ? 'translateX(-20px)' : 'translateX(0)'
                          }}
                        >
                          <div className="mb-2">
                            <label htmlFor="email" className="form-label">
                              Email <span className="text-danger">*</span>
                            </label>
                            <input
                              id="email"
                              type="email"
                              className="form-control"
                              placeholder="Enter email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              autoComplete="email"
                              autoFocus
                            />
                            {formErrors.email && <p className='text-danger small mt-1 mb-0'>{formErrors.email}</p>}
                          </div>

                          <div className="mb-3">
                            {/* <div className="float-end">
                              <a
                                href="/password/reset"
                                className="text-muted text-decoration-underline"
                              >
                                Forgot password?
                              </a>
                            </div> */}
                            <label className="form-label" htmlFor="password-input">
                              Password <span className="text-danger">*</span>
                            </label>
                            <div className="position-relative auth-pass-inputgroup input-custom-icon">
                              <input
                                type={showPassword ? 'text' : 'password'}
                                className="form-control"
                                placeholder="Enter password"
                                id="password-input"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                autoComplete="current-password"
                              />
                              {formErrors.password && <p className='text-danger small mt-1 mb-0'>{formErrors.password}</p>}
                              <button
                                type="button"
                                className="btn btn-link d-flex align-items-center justify-content-center position-absolute end-0 top-0 h-100 px-3"
                                id="password-addon"
                                onClick={togglePassword}
                                tabIndex={-1}
                              >
                                <i className={`mdi ${showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'} font-size-18 text-dark`}></i>
                              </button>
                            </div>
                          </div>



                          <div className="mt-4">
                            <button className="btn btn-primary w-100" type="submit">
                              Sign In
                            </button>
                          </div>
                        </form>

                        <form
                          onSubmit={handleAdminUsersSubmit}
                          noValidate
                          className={`auth-input ${activeTab === 'adminUsers' ? '' : 'd-none'}`}
                          style={{
                            transition: 'all 0.3s ease',
                            opacity: isTransitioning ? 0 : 1,
                            transform: isTransitioning ? 'translateX(20px)' : 'translateX(0)'
                          }}
                        >
                          <div className="mb-3">
                            <label htmlFor="phoneNumber" className="form-label">
                              Phone Number <span className="text-danger">*</span>
                            </label>
                            <div className="position-relative auth-pass-inputgroup input-custom-icon">
                              <input
                                id="phoneNumber"
                                type="text"
                                className="form-control"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                // required
                                placeholder="Enter 10-digit phone number"
                                maxLength="10"
                                pattern="\d{10}"
                              />
                              {formErrors.phoneNumber && <p className='text-danger small mt-1 mb-0'>{formErrors.phoneNumber}</p>}
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <label className="form-label mb-0" style={{ fontSize: '0.9rem', fontWeight: '600' }}>
                                PIN <span className="text-danger">*</span>
                              </label>
                              <button
                                type="button"
                                className="text-white text-decoration-underline btn btn-link p-0"
                                style={{ fontSize: '0.85rem', fontWeight: '600', textDecoration: 'none' }}
                                onClick={() => setForgotPasswordActive(true)}
                              >
                                Forgot PIN?
                              </button>
                            </div>

                            <div className="d-flex align-items-center  gap-4">
                              <div className="d-flex gap-2 ">
                                {[0, 1, 2, 3].map((index) => (
                                  <input
                                    key={index}
                                    id={`pin-${index}`}
                                    type={showPin ? "text" : "password"}
                                    className="form-control text-center p-0"
                                    style={{
                                      width: "60px",
                                      height: "48px",
                                      fontSize: "1.2rem",
                                      fontWeight: "bold",
                                      backgroundColor: "white",
                                      border: "none",
                                      borderRadius: "10px",
                                      color: "#333"
                                    }}
                                    value={formData.password[index] || ""}
                                    maxLength={1}
                                    onChange={(e) => handlePinChange(e.target.value, index)}
                                    onKeyDown={(e) => handlePinKeyDown(e, index)}
                                    onPaste={handlePinPaste}
                                    autoComplete="off"
                                  />
                                ))}
                              </div>
                              <button
                                type="button"
                                className="btn btn-link p-0 ms-3 d-flex align-items-center"
                                onClick={() => setShowPin(!showPin)}
                                title={showPin ? "Hide PIN" : "Show PIN"}
                              >
                                <i className={`mdi ${showPin ? 'mdi-eye-off-outline' : 'mdi-eye-outline'} text-white`} style={{ fontSize: "26px", lineHeight: "1" }}></i>
                              </button>
                            </div>
                            {formErrors.password && <p className='text-danger mt-1 mb-0' style={{ fontSize: '0.8rem' }}>{formErrors.password}</p>}
                          </div>

                          <div className="mt-4">
                            <button className="btn btn-primary w-100" type="submit">
                              Sign In
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  ) : (
                    <div className="p-2 mt-4">
                      {!otpSent ? (
                        <div className="forgot-password-step">
                          <p className="text-muted mb-4">Enter your registered phone number to reset your PIN</p>
                          <div className="mb-3">
                            <label htmlFor="forgotPhoneNumber" className="form-label">
                              Phone Number <span className="text-danger">*</span>
                            </label>
                            <input
                              id="forgotPhoneNumber"
                              type="text"
                              className="form-control"
                              name="phoneNumber"
                              value={forgotPasswordData.phoneNumber}
                              onChange={handleForgotPasswordChange}
                              placeholder="Enter 10-digit phone number"
                              maxLength="10"
                              pattern="\d{10}"
                            />
                          </div>
                          <div className="mt-4 d-flex gap-2">
                            <button
                              className="btn btn-secondary w-50"
                              type="button"
                              onClick={() => setForgotPasswordActive(false)}
                            >
                              Back to Login
                            </button>
                            <button
                              className="btn btn-primary w-50"
                              type="button"
                              onClick={handleSendOtp}
                            >
                              Send OTP
                            </button>
                          </div>
                        </div>
                      ) : !otpVerified ? (
                        <div className="forgot-password-step">
                          <p className="text-muted mb-4">
                            OTP sent to {forgotPasswordData.phoneNumber.slice(0, 5)}xxxxx
                            {forgotPasswordData.phoneNumber.slice(9)}
                          </p>
                          <div className="mb-3">
                            <label htmlFor="otpInput" className="form-label">
                              Enter OTP <span className="text-danger">*</span>
                            </label>
                            <input
                              id="otpInput"
                              type="text"
                              className="form-control"
                              name="otp"
                              value={forgotPasswordData.otp}
                              onChange={handleForgotPasswordChange}
                              placeholder="Enter 6-digit OTP"
                              maxLength="6"
                              pattern="\d{6}"
                            />
                          </div>
                          <div className="mt-4 d-flex gap-2">
                            <button
                              className="btn btn-secondary w-50"
                              type="button"
                              onClick={() => {
                                setOtpSent(false);
                                setForgotPasswordData(prev => ({ ...prev, otp: '' }));
                              }}
                            >
                              Change Number
                            </button>
                            <button
                              className="btn btn-primary w-50"
                              type="button"
                              onClick={handleVerifyOtp}
                            >
                              Verify OTP
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="forgot-password-step">
                          <p className="text-muted mb-4">Set your new 4-digit PIN</p>
                          <div className="mb-3">
                            <label htmlFor="newPassword" className="form-label">
                              New PIN <span className="text-danger">*</span>
                            </label>
                            <div className="d-flex align-items-center gap-4">
                              <div className="d-flex gap-2">
                                {[0, 1, 2, 3].map((index) => (
                                  <input
                                    key={index}
                                    id={`newPassword-${index}`}
                                    type={showNewPin ? "text" : "password"}
                                    className="form-control text-center p-0"
                                    style={{
                                      width: "60px",
                                      height: "48px",
                                      fontSize: "1.2rem",
                                      fontWeight: "bold",
                                      backgroundColor: "white",
                                      border: "none",
                                      borderRadius: "10px",
                                      color: "#333"
                                    }}
                                    value={forgotPasswordData.newPassword[index] || ""}
                                    maxLength={1}
                                    onChange={(e) => handleForgotPasswordPinChange(e.target.value, index, 'newPassword')}
                                    onKeyDown={(e) => handleForgotPasswordPinKeyDown(e, index, 'newPassword')}
                                    onPaste={(e) => handleForgotPasswordPinPaste(e, 'newPassword')}
                                    autoComplete="new-password"
                                  />
                                ))}
                              </div>
                              <button
                                type="button"
                                className="btn btn-link p-0 ms-1"
                                onClick={() => setShowNewPin(!showNewPin)}
                                title={showNewPin ? "Hide PIN" : "Show PIN"}
                              >
                                <i className={`mdi ${showNewPin ? 'mdi-eye-off-outline' : 'mdi-eye-outline'} text-white`} style={{ fontSize: "26px", lineHeight: "1" }}></i>
                              </button>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="confirmPassword" className="form-label">
                              Confirm PIN <span className="text-danger">*</span>
                            </label>
                            <div className="d-flex align-items-center gap-4 ">
                              <div className="d-flex gap-2">
                                {[0, 1, 2, 3].map((index) => (
                                  <input
                                    key={index}
                                    id={`confirmPassword-${index}`}
                                    type={showConfirmNewPin ? "text" : "password"}
                                    className="form-control text-center p-0"
                                    style={{
                                      width: "60px",
                                      height: "48px",
                                      fontSize: "1.2rem",
                                      fontWeight: "bold",
                                      backgroundColor: "white",
                                      border: "none",
                                      borderRadius: "10px",
                                      color: "#333"
                                    }}
                                    value={forgotPasswordData.confirmPassword[index] || ""}
                                    maxLength={1}
                                    onChange={(e) => handleForgotPasswordPinChange(e.target.value, index, 'confirmPassword')}
                                    onKeyDown={(e) => handleForgotPasswordPinKeyDown(e, index, 'confirmPassword')}
                                    onPaste={(e) => handleForgotPasswordPinPaste(e, 'confirmPassword')}
                                    autoComplete="new-password"
                                  />
                                ))}
                              </div>
                              <button
                                type="button"
                                className="btn btn-link p-0 ms-1"
                                onClick={() => setShowConfirmNewPin(!showConfirmNewPin)}
                                title={showConfirmNewPin ? "Hide PIN" : "Show PIN"}
                              >
                                <i className={`mdi ${showConfirmNewPin ? 'mdi-eye-off-outline' : 'mdi-eye-outline'} text-white`} style={{ fontSize: "26px", lineHeight: "1" }}></i>
                              </button>
                            </div>
                          </div>
                          <div className="mt-4 d-flex gap-2">
                            <button
                              className="btn btn-secondary w-50"
                              type="button"
                              onClick={() => {
                                setOtpVerified(false);
                                setForgotPasswordData(prev => ({
                                  ...prev,
                                  newPassword: '',
                                  confirmPassword: ''
                                }));
                              }}
                            >
                              Back
                            </button>
                            <button
                              className="btn btn-primary w-50"
                              type="button"
                              onClick={handleResetPassword}
                            >
                              Reset PIN
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="text-center p-4">
                {/* Footer Links */}
                {/* <div className="footer-links mb-2">
                  <a href="/terms-and-conditions" className="text-muted text-decoration-none mx-2">
                    Terms and Conditions
                  </a>
                  <span className="text-muted">|</span>
                  <a href="/privacy-policy" className="text-muted text-decoration-none mx-2">
                    Privacy Policy
                  </a>
                  <span className="text-muted">|</span>
                  <a href="/shipping-policy" className="text-muted text-decoration-none mx-2">
                    Shipping Policy
                  </a>
                  <span className="text-muted">|</span>
                  <a href="/contact-us" className="text-muted text-decoration-none mx-2">
                    Contact Us
                  </a>
                  <span className="text-muted">|</span>
                  <a href="/cancellation-refunds" className="text-muted text-decoration-none mx-2">
                    Cancellation and Refunds
                  </a>
                </div> */}

                <p className="text-muted mb-0">
                  © {new Date().getFullYear()} COLOURS BOUTIQUE. All Rights Reserved. Developed &amp; Maintained
                  By Ocean Softwares
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div >
  );
}